import React, { useState, useContext, useEffect } from "react";
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import { LanguageContext } from "../LanguageContext";
import './SubscriptionForm.css';
import 'react-toastify/dist/ReactToastify.css';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const SubscriptionForm = () => {
    const { t, setLanguage } = useContext(LanguageContext);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        description: ''
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        // Optional: Basic validation before sending
        if (!formData.name.trim() || !formData.email.trim() || !formData.description.trim()) {
            toast.error(t('pleasefillallfields')); // You'll need this translation
            return;
        }

        try {
            axios.post(`${BASE_URL}/api/subscribe`, formData)
                .then(response => {
                    console.log('Subscription successful:', response.data);
                    // Updated to clear all fields including description
                    setFormData({ name: '', email: '', description: '' });
                    toast.success(t('subscriptionsuccessful'));
                })
                .catch(error => {
                    // More specific error handling
                    if (error.response?.status === 409) {
                        toast.error(t('emailalreadysubscribed')); // For duplicate email
                    } else if (error.response?.status === 400) {
                        toast.error(t('invaliddata')); // For validation errors
                    } else {
                        toast.error(t('subscriptionfailed'));
                    }
                    console.error('Subscription error:', error);
                });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="subscription-form-container">
            <form className="subscription-form" onSubmit={handleSubmit}>
                <h2>{t('subscribetomagazine')}</h2>
                <div className="form-group">
                    <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder={t('name')}
                        value={formData.name}
                        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                        required
                    />
                </div>
                <div className="form-group">
                    <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder={t('email')}
                        value={formData.email}
                        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                        required
                    />
                </div>
                <div className="form-group">
                    <textarea
                        id="description"
                        name="description"
                        className="form-control"
                        placeholder={t('description')}
                        value={formData.description}
                        onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                        rows="4"
                        required
                    />
                </div>
                <button type="submit" className="btn" disabled={isSubmitting}>
                    {isSubmitting ? t('submitting') : t('subscribe')}
                </button>
            </form>
            <ToastContainer position="top-center" />
        </div>
    );
};

export default SubscriptionForm;